import { Suspense, lazy } from "react";
import { usePreloader, useScrollEffect } from "./hooks/useEffects";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Preloader from "./components/ui/Preloader";
import ScrollToTop from "./components/ui/ScrollToTop";

// Lazy load de secciones pesadas
const Hero = lazy(() => import("./components/sections/Hero"));
const About = lazy(() => import("./components/sections/About"));
const Services = lazy(() => import("./components/sections/Services"));
const Team = lazy(() => import("./components/sections/Team"));
const Contact = lazy(() => import("./components/sections/Contact"));

// Componente de fallback para Suspense
const SectionFallback = () => (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
);

export default function App() {
  usePreloader();
  useScrollEffect();

  return (
    <>
      <Preloader />
      <Header />

      <main className="main">
        <Suspense fallback={<SectionFallback />}>
          <Hero />
        </Suspense>
        
        <Suspense fallback={<SectionFallback />}>
          <About />
        </Suspense>
        
        <Suspense fallback={<SectionFallback />}>
          <Services />
        </Suspense>
        
        <Suspense fallback={<SectionFallback />}>
          <Team />
        </Suspense>

        <Suspense fallback={<SectionFallback />}>
          <Contact />
        </Suspense>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}
